module.exports = __webpack_public_path__ + "img/bod33.23b88d27.png";